var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ServerSidePropsContext } from 'root/src/client/v2/common/helpers/gsspHelpers';
import { memo } from 'react';
import { DropsListToolbar } from 'root/src/client/v2/_pages/drops/components/DropsListToolbar';
import { DropsList } from 'root/src/client/v2/_pages/drops/components/DropsList';
import { DropsBanner } from 'root/src/client/v2/_pages/drops/components/DropsBanner';
import { WidgetsLayout } from 'root/src/client/v2/common/layouts/WidgetsLayout';
import { DROPS_DEFAULT_TAB } from 'root/src/client/v2/_pages/drops/fixtures/drops.constants';
import { MainLayout } from 'root/src/client/v2/common/layouts/MainLayout';
import { DropsListService } from 'root/src/client/v2/_pages/drops/services/DropsList.service';
import { DropsListFilter } from 'root/src/client/v2/_pages/drops/components/DropsListFilter';
import { DropEventListFiltersContextProvider, } from 'root/src/client/v2/_pages/drops/contexts/dropEventListFilters.context';
import { gsspWrapper } from 'root/src/client/v2/gssp/gsspWrapper';
import { getTRPCServerSideHelpers, } from 'root/src/client/v2/common/helpers/getTRPCServerSideHelpers';
export const DropsPage = memo((props) => {
    const { tabs } = props;
    return (<MainLayout>
			<WidgetsLayout>
				<div className="flex flex-col w-full gap-5 self-center">
					<DropsBanner />
					<DropEventListFiltersContextProvider>
						<DropsListToolbar tabs={tabs}/>
						<DropsListFilter />
						<DropsList />
					</DropEventListFiltersContextProvider>
				</div>
			</WidgetsLayout>
		</MainLayout>);
});
export const getDropsServerSideProps = gsspWrapper((context) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    try {
        const gssp = new ServerSidePropsContext(context);
        const params = DropsListService.getDropsQueryParams(gssp.getQuery());
        const trpcHelpers = yield getTRPCServerSideHelpers(context);
        const dropsListService = new DropsListService(trpcHelpers);
        const drops = yield dropsListService.fetchDrops();
        const availableTabs = DropsListService.getAvailableDropsTabs(drops);
        const queriedTab = availableTabs.find(tab => tab.value === params.tab);
        const isDefaultTab = params.tab === DROPS_DEFAULT_TAB;
        const isEmptyTab = !((_b = (_a = queriedTab === null || queriedTab === void 0 ? void 0 : queriedTab.item) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length);
        const isCustomQuery = !isDefaultTab;
        if (isEmptyTab && isCustomQuery) {
            return DropsListService.redirectToDefaultParams(gssp.ctx);
        }
        return {
            props: {
                trpcState: trpcHelpers.dehydrate(),
                tabs: availableTabs.map((tab) => {
                    return {
                        tabId: tab.id,
                        title: tab.title,
                        value: tab.value,
                    };
                }),
            },
        };
    }
    catch (err) {
        console.info(context);
        console.error(err);
        return {
            props: {
                tabs: DropsListService.getFallbackDropsTabs(),
            },
        };
    }
}));
